module.exports = __webpack_public_path__ + "static/img/tigers.99ad4ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/tigers.jpg
// module id = Vqap
// module chunks = 1